// Declares a string describing build information
window.BUILD = `[${GLOBALS.ENV}] - ${BUILD.NUMBER}`;
